/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  // Ordersify Back-in-Stock submission feedback enhancements
  const initOrdersifyFeedback = () => {
    // Primary container id (if present) and fallback to popup markup
    const container =
      document.getElementById("osf_bis") ||
      document.querySelector(".osf_popup");
    if (!container) return;

    // Observe injected form (Ordersify injects asynchronously)
    const formObserver = new MutationObserver(() => {
      const form = container.querySelector("#osf_bis_form form");
      // Some implementations may not wrap the form the same way; fallback to any form inside container
      const actualForm = form || container.querySelector("form");
      if (!actualForm || actualForm.dataset.osfEnhanced) return;
      actualForm.dataset.osfEnhanced = "true";

      const responseEl =
        container.querySelector(".osf_response") ||
        container.querySelector(".osf_note") ||
        container.querySelector(".osf_desc");
      const submitBtn =
        actualForm.querySelector(".osf_submit_button") ||
        actualForm.querySelector('[type="submit"]');
      let originalBtnText = submitBtn ? submitBtn.textContent.trim() : "";
      let clearTimeoutId = null;

      // Submission handler
      actualForm.addEventListener("submit", () => {
        if (submitBtn && !submitBtn.classList.contains("is-loading")) {
          submitBtn.classList.add("is-loading");
          submitBtn.disabled = true;
          submitBtn.textContent = "Submitting…";
        }
        if (responseEl) {
          responseEl.classList.add("pending");
          // Show immediate pending feedback if empty
          const msg = responseEl.querySelector(".osf_message");
          if (msg && !msg.textContent.trim()) {
            msg.textContent = "Submitting…";
          }
        }

        // Fail-safe: clear loading after 12s if no success or error detected
        if (clearTimeoutId) clearTimeout(clearTimeoutId);
        clearTimeoutId = setTimeout(() => {
          if (submitBtn) {
            submitBtn.classList.remove("is-loading");
            submitBtn.disabled = false;
            submitBtn.textContent = originalBtnText;
          }
          if (responseEl) responseEl.classList.remove("pending");
        }, 12000);
      });

      // Observe for success message changes
      if (responseEl) {
        const successObserver = new MutationObserver(() => {
          const msg = responseEl.querySelector(".osf_message") || responseEl;
          const text = msg ? (msg.textContent || "").trim() : "";
          // Heuristic: success when green text added (Ordersify sets color inline) or contains certain phrases
          if (
            text &&
            /first to know|thank|subscribed|success|we'll let you know/i.test(
              text
            )
          ) {
            responseEl.classList.remove("pending");
            responseEl.classList.add("success");
            if (submitBtn) {
              submitBtn.classList.remove("is-loading");
              submitBtn.disabled = true; // keep disabled after success
              submitBtn.textContent = originalBtnText;
            }
            if (clearTimeoutId) clearTimeout(clearTimeoutId);
          }
          // Error heuristic: presence of error keywords or inline styles denoting red
          if (text && /invalid|error|try again|failed/i.test(text)) {
            responseEl.classList.remove("pending");
            responseEl.classList.add("error");
            if (submitBtn) {
              submitBtn.classList.remove("is-loading");
              submitBtn.disabled = false;
              submitBtn.textContent = originalBtnText;
            }
            if (clearTimeoutId) clearTimeout(clearTimeoutId);
          }
        });
        successObserver.observe(responseEl, {
          subtree: true,
          childList: true,
          characterData: true,
        });
      }

      // Safety net: clear loading when the form disables/enables submit or resets
      const stateObserver = new MutationObserver(() => {
        if (!submitBtn) return;
        const disabled =
          submitBtn.disabled ||
          submitBtn.getAttribute("aria-disabled") === "true";
        if (!disabled && submitBtn.classList.contains("is-loading")) {
          submitBtn.classList.remove("is-loading");
          submitBtn.textContent = originalBtnText;
        }
      });
      if (submitBtn)
        stateObserver.observe(submitBtn, {
          attributes: true,
          attributeFilter: ["disabled", "aria-disabled", "class"],
        });
    });

    formObserver.observe(container, { subtree: true, childList: true });
  };

  // Run after document complete; if script deferred it may already be ready
  if (document.readyState === "complete") {
    initOrdersifyFeedback();
  } else {
    window.addEventListener("load", initOrdersifyFeedback);
  }

  // Weglot caret color control (EU store only)
  const updateWeglotCaretColor = () => {
    // Only apply for EU store
    if (
      !window.Shopify ||
      !window.Shopify.shop ||
      !window.Shopify.shop.includes("mustard-made-eu")
    ) {
      return;
    }

    const desktopContainer = document.getElementById(
      "header__desktop_static-wg"
    );
    const mobileContainer = document.getElementById("header__mobile_static-wg");

    if (!desktopContainer && !mobileContainer) return;

    // Check if a custom weglot color is set via the CSS variable on the desktop container
    let weglotColor = "";
    if (desktopContainer) {
      const containerStyles = window.getComputedStyle(desktopContainer);
      weglotColor = containerStyles.getPropertyValue("--weglot-color").trim();
    }

    // When a custom color is set via the schema, the inline CSS handles everything
    // We only need the weglot--white-caret class for auto-detection mode
    if (weglotColor) {
      // Custom color is set - remove the auto-detection class and let CSS handle it
      [desktopContainer, mobileContainer].forEach((container) => {
        if (container) {
          container.classList.remove("weglot--white-caret");
        }
      });
    } else {
      // No custom color: auto-detect based on nav link color
      const navlink = document.querySelector(".navlink--toplevel");
      if (navlink) {
        const computedStyle = window.getComputedStyle(navlink);
        const navlinkColor = computedStyle.color;
        const rgb = navlinkColor.match(/\d+/g);
        const shouldBeWhite =
          rgb &&
          rgb.length >= 3 &&
          parseInt(rgb[0]) > 240 &&
          parseInt(rgb[1]) > 240 &&
          parseInt(rgb[2]) > 240;

        [desktopContainer, mobileContainer].forEach((container) => {
          if (container) {
            if (shouldBeWhite) {
              container.classList.add("weglot--white-caret");
            } else {
              container.classList.remove("weglot--white-caret");
            }
          }
        });
      }
    }
  };

  // Run weglot caret color update on load and when announcement bar changes
  if (document.readyState === "complete") {
    // Small delay to ensure announcement bar styles are applied
    setTimeout(updateWeglotCaretColor, 100);
  } else {
    window.addEventListener("load", () => {
      setTimeout(updateWeglotCaretColor, 100);
    });
  }

  // Listen for announcement bar section updates (theme editor live reload)
  document.addEventListener("shopify:section:load", (e) => {
    // Run after a short delay to ensure new styles are applied
    setTimeout(updateWeglotCaretColor, 100);
  });

  document.addEventListener("shopify:section:unload", (e) => {
    setTimeout(updateWeglotCaretColor, 100);
  });

  // Which bundle group applies to a locker. "original-us" only renders on the US
  // store, so its DOM presence routes The Shorty / The Skinny to the US key.
  // Falls back to the first configured group before any locker is picked.
  const defaultBundleGroupType = () => {
    if (document.querySelector('[data-bundle-group="original"]')) return "original";
    const first = document.querySelector("[data-bundle-group]");
    return first ? first.dataset.bundleGroup : null;
  };

  const resolveBundleGroupType = (lockerValue) => {
    const value = (lockerValue || "").trim();
    if (!value) return defaultBundleGroupType();
    const lower = value.toLowerCase();
    if (lower.includes("glass")) return "glass";
    if (
      (lower.includes("shorty") || lower.includes("skinny")) &&
      document.querySelector('[data-bundle-group="original-us"]')
    ) {
      return "original-us";
    }
    return "original";
  };

  // Bundle variant store. Liquid's product.variants caps at 250 but the key
  // product has 599 numbers, so key variants come from /products/<handle>.js?page=N
  // (paged, cached per pageview) rather than inlined. Keyring variants stay inlined
  // for the swatches and are seeded by readBundleProductJson.
  const BUNDLE_VARIANTS_PER_PAGE = 250;
  const BUNDLE_MAX_VARIANT_PAGES = 10;

  const bundleVariantStore = (() => {
    const byHandle = new Map();

    const entry = (handle) => {
      let e = byHandle.get(handle);
      if (!e) {
        e = { variants: new Map(), pages: new Map(), lastPage: null };
        byHandle.set(handle, e);
      }
      return e;
    };

    const seed = (handle, variants) => {
      if (!handle) return null;
      const e = entry(handle);
      (variants || []).forEach((v) => {
        if (v && v.id != null) e.variants.set(String(v.id), v);
      });
      return e;
    };

    const numberOf = (v) => parseInt(String(v && v.title).replace(/\D/g, ''), 10);

    const byNumber = (handle, num) => {
      if (!handle) return null;
      const values = entry(handle).variants.values();
      for (const v of values) {
        if (numberOf(v) === num) return v;
      }
      return null;
    };

    const byId = (handle, id) =>
      handle ? entry(handle).variants.get(String(id)) || null : null;

    // Each page is requested at most once per pageview; concurrent callers share
    // the one promise. A failed request is NOT cached, so a retry can succeed.
    const fetchPage = (handle, page) => {
      const e = entry(handle);
      if (e.pages.has(page)) return e.pages.get(page);
      const root =
        window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';
      const url = `${root}products/${encodeURIComponent(handle)}.js?page=${page}`;
      const req = fetch(url, { headers: { Accept: 'application/json' } })
        .then((res) => {
          if (!res.ok) throw new Error(`HTTP ${res.status}`);
          return res.json();
        })
        .then((json) => {
          const variants = (json && json.variants) || [];
          seed(handle, variants);
          // An empty page marks the end of the list, so page walking can stop.
          if (!variants.length && (e.lastPage === null || page < e.lastPage)) e.lastPage = page;
          return variants.length;
        })
        .catch((err) => {
          e.pages.delete(page);
          throw err;
        });
      e.pages.set(page, req);
      return req;
    };

    // Resolve a typed key number. The common case is one request: variants are
    // numbered in order, so number N sits on page ceil(N / 250). Gaps in the
    // numbering can shift that, so if the computed page misses we walk the pages
    // from the start until the number turns up or an empty page ends the list.
    const ensureNumber = (handle, num) => {
      if (!handle) return Promise.resolve(null);
      const hit = byNumber(handle, num);
      if (hit) return Promise.resolve(hit);

      const guess = Math.ceil(num / BUNDLE_VARIANTS_PER_PAGE) || 1;

      const walk = (page) => {
        const e = entry(handle);
        if (page > BUNDLE_MAX_VARIANT_PAGES) return Promise.resolve(null);
        if (e.lastPage !== null && page >= e.lastPage) return Promise.resolve(null);
        if (e.pages.has(page)) return walk(page + 1);
        return fetchPage(handle, page).then((count) => {
          const found = byNumber(handle, num);
          if (found) return found;
          if (!count) return null;
          return walk(page + 1);
        });
      };

      return fetchPage(handle, guess).then(
        () => byNumber(handle, num) || walk(1),
      );
    };

    const prefetch = (handle, page) => {
      if (!handle) return Promise.resolve(0);
      return fetchPage(handle, page || 1).catch(() => 0);
    };

    return { seed, byId, byNumber, ensureNumber, prefetch };
  })();

  // Parse a .key-bundle__product's inlined JSON, seeding any inlined variants
  // into the store the first time it is read.
  const readBundleProductJson = (container) => {
    const jsonEl = container
      ? container.querySelector('[data-bundle-product-json]')
      : null;
    if (!jsonEl) return null;
    let json;
    try {
      json = JSON.parse(jsonEl.textContent);
    } catch (e) {
      console.error(
        '[KeyBundle] product JSON parse error',
        e,
        jsonEl.textContent.trim().slice(0, 120),
      );
      return null;
    }
    if (json && json.handle && jsonEl.dataset.variantsSeeded !== 'true') {
      bundleVariantStore.seed(json.handle, json.variants);
      jsonEl.dataset.variantsSeeded = 'true';
    }
    return json;
  };

  const initKeyReplacementBackground = () => {
    const targetHandle = "replacement-keys";

    const getProductHandle = (productEl) => {
      if (!productEl) return "";
      if (productEl.dataset.productHandle) {
        return productEl.dataset.productHandle;
      }

      const jsonEl = productEl.querySelector("[data-product-json]");
      if (jsonEl) {
        try {
          const productData = JSON.parse(jsonEl.textContent);
          if (productData && productData.handle) {
            productEl.dataset.productHandle = productData.handle;
            return productData.handle;
          }
        } catch (e) {
          // Ignore parse errors and fallback to URL.
        }
      }

      const match = window.location.pathname.match(/\/products\/([^/?#]+)/i);
      const handle = match ? match[1] : "";
      if (handle) {
        productEl.dataset.productHandle = handle;
      }
      return handle;
    };

    const isTargetProduct = (productEl) => {
      const handle = getProductHandle(productEl);
      if (!handle) return false;
      return handle === targetHandle || handle.startsWith(`${targetHandle}-`);
    };

    const getVariantColourMap = (productEl) => {
      if (!productEl) return null;
      if (productEl._variantColourMap !== undefined) {
        return productEl._variantColourMap;
      }

      const mapEl = productEl.querySelector("[data-variant-colour-map]");
      if (!mapEl) {
        productEl._variantColourMap = null;
        return null;
      }

      try {
        const parsed = JSON.parse(mapEl.textContent);
        productEl._variantColourMap = parsed && typeof parsed === "object" ? parsed : null;
      } catch (e) {
        productEl._variantColourMap = null;
      }

      return productEl._variantColourMap;
    };

    const getSwatchColorMap = (productEl) => {
      if (!productEl) return null;
      if (productEl._swatchColorMap !== undefined) {
        return productEl._swatchColorMap;
      }

      const mapEl = productEl.querySelector("[data-swatch-color-map]");
      if (!mapEl) {
        productEl._swatchColorMap = null;
        return null;
      }

      try {
        const parsed = JSON.parse(mapEl.textContent);
        productEl._swatchColorMap = parsed && typeof parsed === "object" ? parsed : null;
      } catch (e) {
        productEl._swatchColorMap = null;
      }

      return productEl._swatchColorMap;
    };

    const getSelectedVariantId = (productEl) => {
      if (!productEl) return "";
      const idInput = productEl.querySelector('form [name="id"]');
      return idInput ? idInput.value : "";
    };

    const handleize = (value) => {
      if (!value) return "";
      return value
        .toString()
        .toLowerCase()
        .replace(/['"]/g, "")
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
    };

    const getColorOptionWrapper = (container) => {
      if (!container) return null;
      const wrappers = container.querySelectorAll("[data-option-position]");
      for (const wrapper of wrappers) {
        const nameEl = wrapper.querySelector(".radio__legend__option-name");
        if (!nameEl) continue;
        const name = nameEl.textContent || "";
        if (/colou?r/i.test(name)) {
          return wrapper;
        }
      }
      return null;
    };

    const getSelectedSwatchLabel = (wrapper) => {
      if (!wrapper) return null;
      return wrapper.querySelector(
        'input[type="radio"][data-single-option-selector]:checked + label[data-swatch]'
      );
    };

    const getSelectedValueFromWrapper = (wrapper) => {
      if (!wrapper) return "";
      const checkedInput = wrapper.querySelector(
        "input[data-single-option-selector]:checked"
      );
      if (checkedInput && checkedInput.value) {
        return checkedInput.value;
      }

      const popoutInput = wrapper.querySelector(
        "input[data-popout-input][data-single-option-selector]"
      );
      if (popoutInput && popoutInput.value) {
        return popoutInput.value;
      }

      const valueEl = wrapper.querySelector("[data-option-value]");
      if (valueEl && valueEl.textContent) {
        return valueEl.textContent.trim();
      }

      return "";
    };

    const getSelectedSwatchColor = (container) => {
      const wrapper = getColorOptionWrapper(container) || container;
      const label = getSelectedSwatchLabel(wrapper);
      if (!label) return "";

      const styles = window.getComputedStyle(label);
      const bgColor = styles.backgroundColor;
      if (bgColor && bgColor !== "transparent" && bgColor !== "rgba(0, 0, 0, 0)") {
        return bgColor;
      }

      const bgImage = styles.backgroundImage;
      if (bgImage && bgImage !== "none") {
        return "";
      }

      return "";
    };

    const getSelectedColorValue = (container, swatchMap) => {
      const wrapper = getColorOptionWrapper(container);

      if (wrapper) {
        const swatchLabel = getSelectedSwatchLabel(wrapper);
        if (swatchLabel) {
          const swatchName = swatchLabel.getAttribute("data-swatch") || "";
          return swatchName.trim();
        }

        const directValue = getSelectedValueFromWrapper(wrapper);
        if (directValue) return directValue;
      }

      if (swatchMap && typeof swatchMap === "object") {
        const wrappers = container.querySelectorAll("[data-option-position]");
        for (const optionWrapper of wrappers) {
          const optionValue = getSelectedValueFromWrapper(optionWrapper);
          if (!optionValue) continue;
          const key = handleize(optionValue);
          if (key && swatchMap[key]) {
            return optionValue;
          }
        }
      }

      return "";
    };

    const parseRgb = (color) => {
      if (!color) return null;
      const parts = color.match(/[\d.]+/g);
      if (!parts || parts.length < 3) return null;
      const r = Number(parts[0]);
      const g = Number(parts[1]);
      const b = Number(parts[2]);
      if ([r, g, b].some((value) => Number.isNaN(value))) return null;
      return { r, g, b };
    };

    const getLuminance = ({ r, g, b }) => {
      const channels = [r, g, b].map((value) => {
        const srgb = value / 255;
        return srgb <= 0.03928
          ? srgb / 12.92
          : Math.pow((srgb + 0.055) / 1.055, 2.4);
      });
      return (
        0.2126 * channels[0] + 0.7152 * channels[1] + 0.0722 * channels[2]
      );
    };

    const getAutoContrast = (bgColor) => {
      const rgb = parseRgb(bgColor);
      if (!rgb) return null;
      const luminance = getLuminance(rgb);
      const useWhiteText = luminance < 0.5;
      const textColor = useWhiteText ? "#FFFFFF" : "#0A0A0A";
      return { textColor, iconColor: textColor, useWhiteText };
    };

    let desiredHeaderWhiteText = false;
    let headerContrastScheduled = false;

    const getHeaderWrapper = () => {
      return (
        document.querySelector("[data-header-wrapper]") ||
        document.querySelector(".header__wrapper")
      );
    };

    const hasOpenHeaderDisclosure = () => {
      const wrapper = getHeaderWrapper();
      if (!wrapper) return false;
      return Boolean(
        wrapper.querySelector("hover-disclosure.is-visible, .hover-disclosure.is-visible")
      );
    };

    const applyHeaderContrast = () => {
      const headerDesktop = document.querySelector(".header__desktop");
      const headerMobile = document.querySelector(".header__mobile");
      const allowWhiteText = !hasOpenHeaderDisclosure();
      const useWhiteText = desiredHeaderWhiteText && allowWhiteText;
      [headerDesktop, headerMobile].forEach((headerEl) => {
        if (headerEl) {
          headerEl.classList.toggle("use-white-text", useWhiteText);
        }
      });
    };

    const isProductTemplate = () => {
      return document.body && document.body.classList.contains("template-product");
    };

    const scheduleHeaderContrastApply = () => {
      if (headerContrastScheduled) return;
      headerContrastScheduled = true;
      requestAnimationFrame(() => {
        headerContrastScheduled = false;
        applyHeaderContrast();
      });
    };

    const ensureHeaderDisclosureObserver = () => {
      const wrapper = getHeaderWrapper();
      if (!wrapper || wrapper._keyReplacementHeaderObserver) return;
      wrapper._keyReplacementHeaderObserver = true;

      const observer = new MutationObserver(() => {
        scheduleHeaderContrastApply();
      });

      observer.observe(wrapper, {
        subtree: true,
        attributes: true,
        attributeFilter: ["class"],
      });
    };

    const setHeaderContrast = (useWhiteText) => {
      desiredHeaderWhiteText = Boolean(useWhiteText);
      ensureHeaderDisclosureObserver();
      scheduleHeaderContrastApply();
    };

    if (!isProductTemplate()) return;
    const pageMatch = window.location.pathname.match(/\/products\/([^/?#]+)/i);
    const pageHandle = pageMatch ? pageMatch[1] : "";
    if (
      !pageHandle ||
      !(pageHandle === targetHandle || pageHandle.startsWith(`${targetHandle}-`))
    ) {
      return;
    }

    const updateFooterWave = (productEl, color, contrast) => {
      const footer = document.querySelector(".footer-sections");
      const wave = document.querySelector(".swatch-up");
      if (!footer && !wave) return;

      const inlineStyle = productEl ? productEl.getAttribute("style") : "";
      let mappedStyle = "";

      if (inlineStyle && inlineStyle.includes("--pdp-background")) {
        mappedStyle = inlineStyle
          .replace(/--pdp-background/g, "--swatch-background")
          .replace(/--product-text-colour/g, "--swatch-text-colour")
          .replace(/--product-icon-colour/g, "--swatch-icon-colour");
      } else if (color && contrast) {
        mappedStyle = `--swatch-background: ${color}; --swatch-text-colour: ${contrast.textColor}; --swatch-icon-colour: ${contrast.iconColor};`;
      }

      if (!mappedStyle) return;

      if (footer) {
        footer.setAttribute("style", mappedStyle);
        footer.classList.add("pdp-footer");
      }
      if (wave) {
        wave.setAttribute("style", mappedStyle);
      }
    };

    const hasBundleMode = () => {
      return Boolean(document.querySelector("[data-bundle-group]"));
    };

    const getActiveBundleSwatchColor = () => {
      const lockerInput = document.querySelector(".locker-required-input");
      // Resolve against the default group when no locker is picked yet.
      const bundleType = resolveBundleGroupType(lockerInput ? lockerInput.value : "");
      if (!bundleType) return "";
      const activeGroup = document.querySelector(`[data-bundle-group="${bundleType}"]`);
      if (!activeGroup) return "";
      const checkedSwatch = activeGroup.querySelector("[data-bundle-colour-swatch]:checked");
      if (!checkedSwatch) return "";
      const label = checkedSwatch.nextElementSibling;
      if (!label) return "";
      const bgColor = window.getComputedStyle(label).backgroundColor;
      if (!bgColor || bgColor === "transparent" || bgColor === "rgba(0, 0, 0, 0)") return "";
      return bgColor;
    };

    const clearBackground = (productEl) => {
      productEl.setAttribute("style", productEl._originalStyle || "");
      productEl.classList.remove("use-white-text");
      setHeaderContrast(false);
      const footer = document.querySelector(".footer-sections");
      const wave = document.querySelector(".swatch-up");
      if (footer) {
        footer.removeAttribute("style");
        footer.classList.remove("pdp-footer");
      }
      if (wave) wave.removeAttribute("style");
    };

    const updateBackground = (productEl, variantId) => {
      if (!productEl || !isTargetProduct(productEl)) return;
      if (!isProductTemplate()) return;
      if (productEl._originalStyle === undefined) {
        productEl._originalStyle = productEl.getAttribute("style") || "";
      }
      if (hasBundleMode()) {
        // Default group's swatch drives the background on load; no locker needed.
        const color = getActiveBundleSwatchColor();
        if (!color) return;
        productEl.style.setProperty("--pdp-background", color);
        const contrast = getAutoContrast(color);
        if (contrast) {
          productEl.style.setProperty("--product-text-colour", contrast.textColor);
          productEl.style.setProperty("--product-icon-colour", contrast.iconColor);
          productEl.classList.toggle("use-white-text", contrast.useWhiteText);
          setHeaderContrast(contrast.useWhiteText);
          updateFooterWave(productEl, color, contrast);
        }
        return;
      }
      const map = getVariantColourMap(productEl);
      const resolvedVariantId = variantId || getSelectedVariantId(productEl);
      const mapEntry = map && resolvedVariantId ? map[resolvedVariantId] : null;
      let color = mapEntry && mapEntry.hex ? mapEntry.hex : "";
      if (!color) {
        const swatchMap = getSwatchColorMap(productEl);
        const swatchName = getSelectedColorValue(productEl, swatchMap);
        const swatchKey = handleize(swatchName);
        if (swatchMap && swatchKey && swatchMap[swatchKey]) {
          color = swatchMap[swatchKey];
        }
      }
      if (!color) {
        color = getSelectedSwatchColor(productEl);
      }
      if (!color) return;

      productEl.style.setProperty("--pdp-background", color);

      const contrast = mapEntry && typeof mapEntry.white_text === "boolean"
        ? {
            textColor: mapEntry.white_text ? "#FFFFFF" : "#0A0A0A",
            iconColor: mapEntry.white_text ? "#FFFFFF" : "#0A0A0A",
            useWhiteText: mapEntry.white_text,
          }
        : getAutoContrast(color);
      if (contrast) {
        productEl.style.setProperty("--product-text-colour", contrast.textColor);
        productEl.style.setProperty(
          "--product-icon-colour",
          contrast.iconColor
        );
        productEl.classList.toggle("use-white-text", contrast.useWhiteText);
        setHeaderContrast(contrast.useWhiteText);
        updateFooterWave(productEl, color, contrast);
      }
    };

    document.addEventListener("theme:variant:change", (evt) => {
      const variantId = evt.detail && evt.detail.variant ? evt.detail.variant.id : "";
      const productEl =
        evt.target && evt.target.closest
          ? evt.target.closest("product-component")
          : null;
      if (!productEl) return;
      updateBackground(productEl, variantId);
    });

    document.querySelectorAll("product-component").forEach((productEl) => {
      updateBackground(productEl);

      if (!productEl._keyReplacementListeners) {
        productEl._keyReplacementListeners = true;
        productEl.addEventListener("change", (event) => {
          const target = event.target;
          if (
            target &&
            target.matches &&
            (target.matches("[data-single-option-selector]") ||
             target.matches("[data-bundle-colour-swatch]"))
          ) {
            updateBackground(productEl);
          }
        });

        productEl.addEventListener("click", (event) => {
          const option = event.target && event.target.closest
            ? event.target.closest("[data-popout-option]")
            : null;
          if (option) {
            setTimeout(() => updateBackground(productEl), 0);
          }
        });
      }
    });
  };

  const initLockerValidationMessage = () => {
    const inputs = document.querySelectorAll("[data-locker-required-message]");
    inputs.forEach((input) => {
      if (input._lockerMessageBound) return;
      input._lockerMessageBound = true;

      const message =
        input.getAttribute("data-locker-required-message") ||
        "Please select a locker.";

      const updateValidity = () => {
        const hasValue = Boolean(input.value && input.value.trim());
        input.setCustomValidity(hasValue ? "" : message);
      };

      updateValidity();
      input.addEventListener("invalid", updateValidity);
      input.addEventListener("input", updateValidity);
      input.addEventListener("change", updateValidity);

      const scope = input.closest("product-component") || document;
      scope.addEventListener("click", (event) => {
        const option = event.target && event.target.closest
          ? event.target.closest("[data-popout-option]")
          : null;
        if (option) {
          setTimeout(updateValidity, 0);
        }
      });
    });
  };

  // Legacy (non-bundle) replacement key PDP, live on EU/US: show an error line
  // under the key box as soon as a 3-character key number breaks the input's
  // pattern (000 to 600), or when the customer leaves a shorter number. The
  // pattern in snippets/key-engraving-form.liquid stays the only rule; Add to
  // Basket is still blocked by the theme's form.checkValidity().
  const initLegacyKeyNumberCheck = () => {
    const input = document.querySelector(
      '.key-engraving-form-mobile-wrapper input[name="properties[Key #]"]',
    );
    if (!input || input._keyNumberCheckBound) return;
    input._keyNumberCheckBound = true;

    const feedback = document.getElementById(
      input.getAttribute("aria-describedby"),
    );
    const message = input.title || "Enter a key number from 000 to 600.";

    // While typing, a 1 or 2 digit entry is not finished yet, so it is only
    // flagged on "change" (when the customer leaves the box).
    const check = (flagShortNumbers) => {
      input.setCustomValidity("");
      const invalid = input.validity.patternMismatch;
      if (invalid) input.setCustomValidity(message);

      if (invalid && (flagShortNumbers || input.value.length >= 3)) {
        input.setAttribute("aria-invalid", "true");
        if (feedback) feedback.textContent = message;
      } else if (!invalid) {
        input.removeAttribute("aria-invalid");
        if (feedback) feedback.textContent = "";
      }
    };

    input.addEventListener("input", () => check(false));
    input.addEventListener("change", () => check(true));
    // Add to Basket's validity check fires "invalid" even when the box never
    // lost focus (no "change"), so a short number is still flagged.
    input.addEventListener("invalid", () => check(true));
  };

  // Shared key-number box: resolves the typed number against the active group's
  // key product JSON and writes the variant id to that group's hidden input.
  // OOS state rides on the hidden input's dataset for cross-block notify detection.
  const initKeyBundleNumberInput = () => {
    const box = document.querySelector("[data-bundle-key-number]");
    if (!box) return;
    const feedback = document.querySelector("[data-bundle-key-feedback]");
    const lockerInput = document.querySelector(".locker-required-input");

    const activeKey = () => {
      const type = resolveBundleGroupType(lockerInput ? lockerInput.value : "");
      const group = type ? document.querySelector(`[data-bundle-group="${type}"]`) : null;
      const hidden = group ? group.querySelector("[data-bundle-key-input]") : null;
      const productEl = hidden ? hidden.closest(".key-bundle__product") : null;
      const json = readBundleProductJson(productEl);
      return { hidden, handle: json ? json.handle : '' };
    };

    // Every resolution carries a token. Looking a number up can now cost a
    // network request, so a response can land after the customer has typed a
    // different number or switched locker. Anything that resolves late compares
    // its token before committing and drops itself if it has been superseded.
    let resolveToken = 0;

    const resolve = () => {
      const { hidden, handle } = activeKey();
      box.classList.remove("is-unavailable", "is-invalid");
      resolveToken += 1;
      const token = resolveToken;
      const current = () => token === resolveToken;

      const commit = (variantId, message, unavailable) => {
        if (hidden) {
          hidden.value = variantId || "";
          hidden.dataset.unavailable = unavailable ? "true" : "";
          hidden.dispatchEvent(new Event("change", { bubbles: true }));
        }
        if (feedback) feedback.textContent = message || "";
      };

      // No locker chosen yet → nothing to resolve against.
      if (!hidden) {
        if (feedback) feedback.textContent = "";
        return;
      }

      const raw = box.value.trim();
      if (raw === "") {
        commit("", "", false);
        return;
      }

      const num = parseInt(raw.replace(/\D/g, ""), 10);
      if (isNaN(num) || num < 0 || num > 600) {
        box.classList.add("is-invalid");
        commit("", "Enter a key number from 000 to 600.", false);
        return;
      }

      const apply = (variant) => {
        if (!current()) return;
        if (!variant) {
          box.classList.add("is-invalid");
          commit("", "No matching key found.", false);
          return;
        }
        const padded = String(num).padStart(3, "0");
        if (!variant.available) {
          box.classList.add("is-unavailable");
          commit(variant.id, `Key #${padded} is out of stock.`, true);
          return;
        }
        commit(variant.id, `Key #${padded} selected.`, false);
      };

      // Cache hit resolves synchronously, so typing a number already loaded
      // never flickers or waits.
      const cached = bundleVariantStore.byNumber(handle, num);
      if (cached) {
        apply(cached);
        return;
      }

      bundleVariantStore
        .ensureNumber(handle, num)
        .then(apply)
        .catch(() => {
          if (!current()) return;
          box.classList.add("is-invalid");
          commit(
            '',
            'Could not check that key number. Please try again.',
            false,
          );
        });
    };

    // Warm the first page for the group the customer just selected, so by the
    // time three digits are typed the data is usually already here.
    const prefetchActiveKeyProduct = () => {
      const { handle } = activeKey();
      if (handle) bundleVariantStore.prefetch(handle, 1);
    };

    box.addEventListener("input", resolve);
    box.addEventListener("change", resolve);
    // Locker switch re-resolves the same typed number against the new group.
    if (lockerInput) {
      lockerInput.addEventListener("change", () => {
        prefetchActiveKeyProduct();
        setTimeout(resolve, 0);
      });
    }
    prefetchActiveKeyProduct();
  };

  const initKeyBundleColourSwatches = () => {
    document.querySelectorAll("[data-bundle-keyring]").forEach((container) => {
      const variantInput = container.querySelector("[data-bundle-variant-id]");
      const optionValueEl = container.querySelector("[data-bundle-colour-value]");
      if (!variantInput) return;

      const updateOptionValue = (swatch) => {
        if (optionValueEl) {
          optionValueEl.textContent = swatch.value;
        }
      };

      const checkedSwatch = container.querySelector("[data-bundle-colour-swatch]:checked");
      if (checkedSwatch) updateOptionValue(checkedSwatch);

      container.querySelectorAll("[data-bundle-colour-swatch]").forEach((swatch) => {
        swatch.addEventListener("change", () => {
          if (swatch.dataset.variantId) {
            variantInput.value = swatch.dataset.variantId;
          }
          updateOptionValue(swatch);
        });
      });
    });
  };

  const initLockerBundleVisibility = () => {
    const bundleGroups = document.querySelectorAll("[data-bundle-group]");
    if (!bundleGroups.length) return;

    const lockerInput = document.querySelector(".locker-required-input");
    if (!lockerInput) return;

    const keyBox = document.querySelector("[data-bundle-key-box]");
    const container = document.querySelector(".product__key-bundle");
    const keyNumberInput = document.querySelector("[data-bundle-key-number]");

    const updateVisibility = () => {
      const lockerSet = lockerInput.value.trim() !== "";
      const type = resolveBundleGroupType(lockerInput.value);
      bundleGroups.forEach((group) => {
        group.hidden = group.dataset.bundleGroup !== type;
      });
      // Key box + palette stay visible with the default group but are locked
      // (dim + non-interactive) until a locker is chosen. .is-locked drives styling.
      if (keyBox) keyBox.hidden = !type;
      if (container) container.classList.toggle("is-locked", !lockerSet);
      if (keyNumberInput) keyNumberInput.disabled = !lockerSet;
    };

    // Tooltip shown when a customer taps the locked key# / palette before choosing
    // a locker. Positioned above the tapped control, auto-hides.
    const gateHint = document.querySelector("[data-bundle-gate-hint]");
    let gateHintTimer;
    const flashGateHint = (anchor) => {
      if (!gateHint || !container || !anchor) return;
      const cRect = container.getBoundingClientRect();
      const aRect = anchor.getBoundingClientRect();
      gateHint.style.top = aRect.top - cRect.top - 8 + "px";
      gateHint.style.left = aRect.left - cRect.left + aRect.width / 2 + "px";
      gateHint.style.transform = "translate(-50%, -100%)";
      gateHint.classList.add("is-visible");
      clearTimeout(gateHintTimer);
      gateHintTimer = setTimeout(() => gateHint.classList.remove("is-visible"), 2500);
    };

    [keyBox]
      .concat(Array.from(document.querySelectorAll(".key-bundle__products")))
      .forEach((el) => {
        if (!el) return;
        el.addEventListener("click", () => {
          if (container && container.classList.contains("is-locked")) {
            flashGateHint(el);
          }
        });
      });

    lockerInput.addEventListener("change", updateVisibility);
    updateVisibility();
  };

  const initBundlePropertySync = () => {
    if (!document.querySelector('[data-bundle-group]')) return;

    const lockerInput = document.querySelector('.locker-required-input');
    if (!lockerInput) return;

    const form = document.querySelector('[data-product-form]');
    if (!form) return;

    const getOrCreateInput = (propName) => {
      let input = form.querySelector(`input[name="${propName}"]`);
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = propName;
        form.appendChild(input);
      }
      return input;
    };

    const toGid = (numericId) => numericId ? `gid://shopify/ProductVariant/${numericId}` : '';

    const resizeImg = (url) => {
      if (!url) return '';
      if (/[?&]width=/.test(url)) return url.replace(/([?&])width=\d+/, '$1width=160');
      return url + (url.includes('?') ? '&' : '?') + 'width=160';
    };

    // Build a "title|variant|image" string for the selected bundle child, used to
    // render the cart child rows (the Cart Transform expansion isn't in Liquid's cart).
    const buildDisplay = (inputEl) => {
      if (!inputEl || !inputEl.value) return '';
      const productEl = inputEl.closest('.key-bundle__product');
      const json = readBundleProductJson(productEl);
      if (!json) return '';
      // Key variants are not inlined, so this reads the shared store. By the time
      // a key id is on the input, resolve() has already put that variant there.
      const variant = bundleVariantStore.byId(json.handle, inputEl.value);
      if (!variant) return '';
      const rawImage = variant.featured_image && variant.featured_image.src
        ? variant.featured_image.src
        : (json.featured_image || '');
      return [json.title, variant.title, resizeImg(rawImage)].join('|');
    };

    const sync = () => {
      const type = resolveBundleGroupType(lockerInput.value);
      const group = type ? document.querySelector(`[data-bundle-group="${type}"]`) : null;

      const keyInput = group ? group.querySelector('[data-bundle-key-input]') : null;
      const keyringInput = group ? group.querySelector('[data-bundle-variant-id]') : null;
      // Out-of-stock picks stay empty so the form's required check refuses the add.
      const keyOos = !!(keyInput && keyInput.dataset.unavailable === 'true');
      const checkedSwatch = group ? group.querySelector('[data-bundle-colour-swatch]:checked') : null;
      const keyringOos = !!(checkedSwatch && checkedSwatch.classList.contains('sold-out'));

      getOrCreateInput('properties[_key_variant_gid]').value = keyOos ? '' : toGid(keyInput ? keyInput.value : '');
      getOrCreateInput('properties[_keyring_variant_gid]').value = keyringOos ? '' : toGid(keyringInput ? keyringInput.value : '');

      getOrCreateInput('properties[_bundle_key]').value = buildDisplay(keyInput);
      getOrCreateInput('properties[_bundle_keyring]').value = buildDisplay(keyringInput);
    };

    lockerInput.addEventListener('change', () => setTimeout(sync, 0));

    document.addEventListener('change', (e) => {
      if (e.target && e.target.matches && (
        e.target.matches('[data-bundle-colour-swatch]') ||
        e.target.matches('[data-bundle-key-input]')
      )) {
        setTimeout(sync, 0);
      }
    });

    // The key popout dispatches a non-bubbling change event, so the delegated listener
    // above never fires for it — bind directly to each key input as well.
    document.querySelectorAll('[data-bundle-key-input]').forEach((input) => {
      input.addEventListener('change', () => setTimeout(sync, 0));
    });

    sync();
  };

  const initBundleNotifyMe = () => {
    if (!document.querySelector('[data-bundle-group]')) return;

    const ORDERSIFY_ENDPOINT = 'https://bis-web-service.ordersify.com/shopify/notifications';

    const getActiveGroup = () =>
      document.querySelector('[data-bundle-group]:not([hidden])');

    const getProductJson = (container) => readBundleProductJson(container);

    // Reads the shared store rather than productJson.variants, which is empty for
    // key products now that their variants are fetched rather than inlined.
    const findVariant = (productJson, variantId) =>
      productJson
        ? bundleVariantStore.byId(productJson.handle, variantId)
        : null;

    const getVariantImage = (variant, productJson) => {
      if (variant.featured_image && variant.featured_image.src) {
        return variant.featured_image.src;
      }
      return productJson.featured_image || '';
    };

    const getOosVariants = () => {
      const group = getActiveGroup();
      if (!group) return [];
      const oos = [];

      // Each OOS entry carries a type + label so the notify form can say what the
      // customer is signing up for (key vs keyring).
      const keyInput = group.querySelector('[data-bundle-key-input]');
      if (keyInput && keyInput.value && keyInput.dataset.unavailable === 'true') {
        const productJson = getProductJson(keyInput.closest('.key-bundle__product'));
        if (productJson) {
          const v = findVariant(productJson, keyInput.value);
          oos.push({
            variantId: keyInput.value,
            productJson,
            type: 'key',
            label: 'Key #' + (v ? v.title : ''),
          });
        }
      }

      const checkedSwatch = group.querySelector('[data-bundle-colour-swatch]:checked');
      if (checkedSwatch && checkedSwatch.classList.contains('sold-out')) {
        const keyringEl = checkedSwatch.closest('.key-bundle__product');
        const productJson = getProductJson(keyringEl);
        const variantId = keyringEl ? keyringEl.querySelector('[data-bundle-variant-id]') : null;
        if (productJson && variantId) {
          const colour = checkedSwatch.value || '';
          const colourLabel = colour ? colour.charAt(0).toUpperCase() + colour.slice(1) : '';
          oos.push({
            variantId: variantId.value,
            productJson,
            type: 'keyring',
            label: 'Keyring – ' + colourLabel,
          });
        }
      }

      return oos;
    };

    const buildPayload = (email, variantId, productJson) => {
      const variant = findVariant(productJson, variantId);
      return {
        email,
        handle: productJson.handle,
        language: document.documentElement.lang || 'en',
        message: '',
        name: null,
        phone: null,
        product_handle: productJson.handle,
        product_id: productJson.id,
        product_title: productJson.title,
        quantity: 1,
        send_type: 'email',
        shop: (window.Shopify && window.Shopify.shop) || 'mustard-made.myshopify.com',
        sku: variant ? variant.sku : '',
        variant_id: String(variantId),
        variant_image: variant ? getVariantImage(variant, productJson) : (productJson.featured_image || ''),
        variant_price: variant ? variant.price : 0,
        variant_title: variant ? variant.title : '',
        vendor: productJson.vendor,
      };
    };

    const postNotification = (payload) =>
      fetch(ORDERSIFY_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload),
      }).then(async (r) => {
        const body = await r.json().catch(() => null);
        if (!r.ok) {
          console.error('[BundleNotifyMe] API error', r.status, body);
          throw new Error(`HTTP ${r.status}`);
        }
        return body;
      });

    const updateNotifyState = () => {
      const group = getActiveGroup();
      const buttonsBlock = document.querySelector('.product__block--buttons');
      const lockerInput = document.querySelector('.locker-required-input');
      // A default group is always active, so ATC gating checks the locker value
      // directly rather than inferring "locker chosen" from group presence.
      const lockerSet = !!(lockerInput && lockerInput.value.trim());

      if (!group) {
        if (buttonsBlock) {
          buttonsBlock.hidden = false;
          const atcBtn = buttonsBlock.querySelector('[data-add-to-cart]');
          if (atcBtn) atcBtn.disabled = true;
        }
        return;
      }

      const notifyEl = group.querySelector('.key-bundle__notify');
      const oosVariants = getOosVariants();
      const hasOos = oosVariants.length > 0;

      const keyInput = group.querySelector('[data-bundle-key-input]');
      const keyMissing = keyInput ? keyInput.value.trim() === '' : false;

      if (notifyEl) notifyEl.hidden = !hasOos;

      // Name what the customer is signing up for; updates live on every change.
      const targetEl = notifyEl ? notifyEl.querySelector('[data-bundle-notify-target]') : null;
      if (targetEl) {
        targetEl.textContent = hasOos
          ? "Get notified when back in stock: " + oosVariants.map((o) => o.label).join(' & ')
          : '';
      }

      if (buttonsBlock) {
        buttonsBlock.hidden = hasOos;
        const atcBtn = buttonsBlock.querySelector('[data-add-to-cart]');
        if (atcBtn) atcBtn.disabled = hasOos || keyMissing || !lockerSet;
        const productForm = buttonsBlock.querySelector('[data-product-form]');
        if (productForm) productForm.dataset.bundleOosDisabled = hasOos ? 'true' : '';
      }
    };

    document.querySelectorAll('[data-bundle-group]').forEach((group) => {
      const notifyEl = group.querySelector('.key-bundle__notify');
      if (!notifyEl) return;

      const emailInput = notifyEl.querySelector('.key-bundle__notify-email');
      const submitBtn = notifyEl.querySelector('.key-bundle__notify-submit');
      const responseEl = notifyEl.querySelector('.key-bundle__notify-response');

      submitBtn.addEventListener('click', async () => {
        const email = emailInput ? emailInput.value.trim() : '';
        if (!email || !emailInput.checkValidity()) {
          emailInput.reportValidity();
          return;
        }

        const oosVariants = getOosVariants();
        console.log('[BundleNotifyMe] oosVariants', oosVariants);
        if (!oosVariants.length) return;

        submitBtn.disabled = true;
        const originalText = submitBtn.textContent;
        submitBtn.textContent = 'Submitting…';
        if (responseEl) responseEl.hidden = true;

        try {
          const results = await Promise.all(
            oosVariants.map(({ variantId, productJson }) =>
              postNotification(buildPayload(email, variantId, productJson))
            )
          );
          const allSuccess = results.every((r) => r === null || (r && r.data === 'success_text'));
          if (responseEl) {
            responseEl.textContent = allSuccess
              ? "You're on the list! We'll email you when these items are back in stock."
              : 'Something went wrong. Please try again.';
            responseEl.dataset.state = allSuccess ? 'success' : 'error';
            responseEl.hidden = false;
          }
          if (allSuccess) {
            submitBtn.textContent = originalText;
          } else {
            submitBtn.disabled = false;
            submitBtn.textContent = originalText;
          }
        } catch (err) {
          console.error('[BundleNotifyMe] caught error', err);
          if (responseEl) {
            responseEl.textContent = 'Something went wrong. Please try again.';
            responseEl.dataset.state = 'error';
            responseEl.hidden = false;
          }
          submitBtn.disabled = false;
          submitBtn.textContent = originalText;
        }
      });
    });

    const lockerInput = document.querySelector('.locker-required-input');
    if (lockerInput) {
      lockerInput.addEventListener('change', () => setTimeout(updateNotifyState, 0));
    }

    document.querySelectorAll('[data-bundle-key-input]').forEach((input) => {
      input.addEventListener('change', () => setTimeout(updateNotifyState, 0));
    });

    document.addEventListener('change', (e) => {
      if (e.target && e.target.matches && e.target.matches('[data-bundle-colour-swatch]')) {
        setTimeout(updateNotifyState, 0);
      }
    });

    // theme.dev.js re-enables the button on every quantity or option change,
    // then fires this event, so re-apply the bundle gate after it.
    document.addEventListener('theme:variant:change', () => setTimeout(updateNotifyState, 0));

    updateNotifyState();
  };

  // Swap the PDP gallery image to match the chosen group + keyring colour (24
  // slides: original/glass x 12 colours, stacked in one grid). Visibility needs BOTH
  // .media--hidden absent AND .media--active present. Slides are matched on alt text
  // ("...replacement key in Berry" vs "...glass replacement key in Berry") so a
  // re-upload doesn't break the match.
  const initKeyBundleGalleryImage = () => {
    if (!document.querySelector('[data-bundle-group]')) return;

    const slides = [
      ...document.querySelectorAll('.product__slides [data-slide]'),
    ];
    if (slides.length < 2) return;

    const lockerInput = document.querySelector('.locker-required-input');

    const describe = (slide) => {
      const img = slide.querySelector('img');
      const alt = ((img && img.alt) || '').toLowerCase().trim();
      const inAt = alt.lastIndexOf(' in ');
      if (inAt === -1) return null;
      return {
        glass: /\bglass\b/.test(alt),
        colour: alt.slice(inAt + 4).trim(),
      };
    };

    const index = new Map();
    slides.forEach((slide) => {
      const d = describe(slide);
      if (!d || !d.colour) return;
      const key = `${d.glass ? 'glass' : 'original'}|${d.colour}`;
      // First slide in DOM order wins; a later duplicate alt would hide the earlier.
      if (!index.has(key)) index.set(key, slide);
    });
    if (!index.size) return;

    // Slides past the first are lazy, so warm just the family in play (not all 24)
    // to avoid an empty frame on first reveal. Fire-and-forget: the swap below must
    // never wait on loading.
    const warmFamily = (family) => {
      index.forEach((slide, key) => {
        if (!key.startsWith(`${family}|`)) return;
        const img = slide.querySelector('img');
        if (img && img.loading === 'lazy') img.loading = 'eager';
      });
    };

    // Prefer the theme's media API (theme:media:select): it also sets
    // data-active-media (moves the highlighted thumbnail) and recalcs gallery
    // height. Toggling classes by hand shows the image but leaves those stale.
    const productImages = slides[0].closest('product-images');

    const reveal = (slide) => {
      const { mediaId } = slide.dataset;
      if (productImages && mediaId) {
        productImages.dispatchEvent(
          new CustomEvent('theme:media:select', { detail: { id: mediaId } }),
        );
        return;
      }
      // Fallback only if the gallery markup changes: visibility needs BOTH
      // .media--hidden absent AND .media--active present.
      slides.forEach((s) => {
        s.classList.toggle('media--hidden', s !== slide);
        s.classList.toggle('media--active', s === slide);
      });
    };

    const activeColour = () => {
      const group = document.querySelector('[data-bundle-group]:not([hidden])');
      const swatch =
        group && group.querySelector('[data-bundle-colour-swatch]:checked');
      return swatch ? String(swatch.value).toLowerCase().trim() : '';
    };

    const update = () => {
      const type = resolveBundleGroupType(lockerInput ? lockerInput.value : '');
      // The US alternative key product is an original key, so it shares artwork.
      const family = type === 'glass' ? 'glass' : 'original';
      const colour = activeColour();
      if (!colour) return;
      const slide = index.get(`${family}|${colour}`);
      // No image for this combination: leave the current one rather than
      // blanking the gallery.
      if (!slide) return;
      warmFamily(family);
      reveal(slide);
    };

    // Deferred a tick: initLockerBundleVisibility swaps the hidden group from its
    // own listener (registered after this), so a sync read would get the old one.
    const queueUpdate = () => setTimeout(update, 0);

    // Swatch changes bubble, so delegation is fine for those.
    document.addEventListener('change', (event) => {
      const { target } = event;
      if (!target || !target.matches) return;
      if (target.matches('[data-bundle-colour-swatch]')) queueUpdate();
    });

    // The locker popout dispatches a NON-bubbling change on its hidden input, so
    // this has to be bound directly. A delegated listener never sees it.
    if (lockerInput) lockerInput.addEventListener('change', queueUpdate);

    update();
  };

  // Extra Shelves: keep the chosen size when switching colour.
  // snippets/product-siblings.liquid renders each colour link with the
  // matching ?variant= on page load, plus a data-sibling-variants map
  // (this product's variant ID -> that colour's variant of the same size).
  // The size selector changes the URL in place without reloading, so point
  // each colour link at the new size here. Bound at the top level (not in
  // initCustomProductEnhancements, which waits for window load) so a size
  // picked before images finish loading is still caught.
  document.addEventListener("theme:variant:change", (evt) => {
    const variant = evt.detail && evt.detail.variant;
    // Also skip events with no variant ID (another app firing a malformed
    // event), so a bad event never strips the correct links.
    if (!variant || !variant.id) return;
    if (!evt.target || !evt.target.closest) return;

    // Quick-add modals fire this event with their own product's variant.
    // (Backup check: the modal is added to <body>, outside any section,
    // so the section lookup below would also find nothing.)
    if (evt.target.closest("[data-quick-add-modal]")) return;

    const section = evt.target.closest("[data-section-type]");
    if (!section) return;

    const links = section.querySelectorAll(".sibling__link[data-sibling-variants]");
    links.forEach((link) => {
      let variantMap;
      try {
        variantMap = JSON.parse(link.dataset.siblingVariants);
      } catch (error) {
        return;
      }

      const url = new URL(link.href);
      const siblingVariantId = variantMap[String(variant.id)];
      if (siblingVariantId) {
        url.searchParams.set("variant", siblingVariantId);
      } else {
        // No same-size variant in this colour: drop any stale ?variant= so
        // the link falls back to the colour's default, as it does today.
        url.searchParams.delete("variant");
      }
      link.setAttribute("href", url.pathname + url.search + url.hash);
    });
  });

  const initCustomProductEnhancements = () => {
    initKeyReplacementBackground();
    initLockerValidationMessage();
    initKeyBundleNumberInput();
    initKeyBundleColourSwatches();
    initKeyBundleGalleryImage();
    initLockerBundleVisibility();
    initBundlePropertySync();
    initBundleNotifyMe();
  };

  // custom.js is deferred, so the key box already exists; bind now rather than
  // waiting for every image to load.
  initLegacyKeyNumberCheck();
  // Theme editor: a re-rendered product section brings a new, unbound key box.
  document.addEventListener("shopify:section:load", initLegacyKeyNumberCheck);

  if (document.readyState === "complete") {
    initCustomProductEnhancements();
  } else {
    window.addEventListener("load", () => {
      initCustomProductEnhancements();
    });
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
